module.exports = __webpack_public_path__ + "static/media/items.3e0500bf.svg";